import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useNavigate, useParams } from 'react-router-dom';
import Alert from '../../../feature/Alert';
import httpClient from '../../../http/HttpRequest';
import ProductCal from '../layout/ProductCal';
import { useTranslation } from 'react-i18next';
import SelectVendor from '../layout/SelectVendor';
import Helper from '../../../helper/Helper';
import { BILL_DETAILS, UPDATE_BILL } from '../../../data/url';

export default function EditBill() {

     //variables
     const [state_id, setState] = useState('');
     const [vendor_id, setVendorId] = useState('');
     const [vendorDetails, setVendorDetails] = useState({});
     const [bill, setBill] = useState({});
     const [vendor, setVendor] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();
     const [errors, setErrors] = useState({});
     const [products, setProducts] = useState([]);
     const [updatedProducts, setUpdatedProducts] = useState([]);
     const [notes, setNotes] = useState({});
     const [billDetail, setBillDetails] = useState({ prefix: '', number: '', bill_date: Helper.getToday(), due_date: '', po_number: '', po_date: '', invoice_number: '' });
     const { id } = useParams();

     useEffect(() => {
          getBillDetails();
     }, [])

     const getBillDetails = async (e) => {
          const res = await httpClient.post(BILL_DETAILS, { bill_id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setVendorId(result.data.bill.vendor_id);
                    setBill(result.data.bill);
                    setProducts(result.data.details);
                    setVendorDetails(result.data.vendor);
               }
          }
     }

     useEffect(() => {
          setNotes({ terms_conditions: bill.terms_conditions, private_notes: bill.private_notes });
          setBillDetails({ prefix: bill.prefix || '', number: bill.bill_number || '', bill_date: bill.bill_date || '', due_date: bill.due_date || '', po_number: bill.po_number || '', po_date: bill.po_date || '', invoice_number: bill.invoice_number || '' })
     }, [vendorDetails, bill]);

     useEffect(() => {
          if (products.length > 0) {
               const data = [];
               products.map((row, index) => {
                    data.push(
                         {
                              selectedProduct: { label: row.product_name, value: row.product_id },
                              desc: row.description,
                              sac: row.sac,
                              selectedUnit: { label: row.unit_name, value: row.unit_id },
                              quantity: row.quantity,
                              price: row.price,
                              discount: row.discount,
                              discountType: row.discountType,
                              tax: row.tax,
                              total: row.net_amount,
                              stock: row.stock,
                              taxableAmount: row.taxable_amount,
                              discountAmount: row.discount_amount,
                              taxAmount: row.tax_amount
                         }
                    )
               })
               setUpdatedProducts(data);
          }

     }, [products]);

     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          setState(data.state_id);
          setVendor(data.vendor);
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...billDetail };
          order[fieldName] = value;
          setBillDetails(order);
     };

     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = billDetail;
                    p['vendor_id'] = vendor_id;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    p['bill_id'] = id;
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(UPDATE_BILL, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/bill');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (vendor_id === '') {
               Alert.error('Kindly select vendor');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="edit_bill" subTitle="bills" subTitleLink="root/bill" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectVendor remitVendor={remitVendor} vendorId={vendor_id} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-4 mt-2'>
                                        <label htmlFor='prefix'>{t('number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={billDetail.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={billDetail.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='bill_date'>{t('bill_date')}</label>
                                        <input id='bill_date' value={billDetail.bill_date} type='date' name='bill_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('bill_date', e)} />
                                   </div>
                                   <div className='col-md-2 mt-2'>
                                        <label htmlFor='due_date'>{t('due_date')}</label>
                                        <input id='due_date' value={billDetail.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='po_number'>{t('po_number')}</label>
                                        <input id='po_number' value={billDetail.po_number} type='text' name='po_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_number', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='po_date'>{t('po_date')}</label>
                                        <input id='po_date' value={billDetail.po_date} type='date' name='po_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_date', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='invoice_number'>{t('invoice_number')}</label>
                                        <input id='invoice_number' value={billDetail.invoice_number} type='text' name='invoice_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_number', e)} />
                                   </div>
                              </div>
                              <ProductCal title="bill" onSubmit={handelSubmit} customer={vendor} products={updatedProducts} notes={notes} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
